import { useState } from 'react'
import { IoClose } from 'react-icons/io5'
import { HiChevronRight } from 'react-icons/hi2'
import SmartLink from 'components/atoms/SmartLink'
import useBodyScrollLock from 'hooks/useBodyScrollLock'
import { 
   GetStartedIcon,
   StartedConnectIcon,
   StartedHelpIcon,
   StartedDiscoverIcon,
   StartedCreateIcon
} from 'assets'

const options = [
   {
      icon: StartedConnectIcon,
      iconBg: 'bg-getStarted-connect-light',
      description: 'Hubungkan perusahaan Anda dengan pembeli dan investor terverifikasi.',
      label: 'Jual Bisnis atau Cari Investor',
      labelColor: 'text-getStarted-connect',
      href: '/seller-landing-page'
   },
   {
      icon: StartedHelpIcon,
      iconBg: 'bg-getStarted-partner-light',
      description: 'Bantu klien Anda, kembangkan bisnis, dan perluas jaringan profesional Anda.',
      label: 'Gabung Sebagai Partner',
      labelColor: 'text-getStarted-partner',
      href: '/join-tomazz'
   },
   {
      icon: StartedDiscoverIcon,
      iconBg: 'bg-getStarted-discover-light',
      description: 'Temukan perusahaan dan peluang investasi terbaik.',
      label: 'Beli Bisnis atau Cari Investasi',
      labelColor: 'text-getStarted-discover',
      href: '/buyer-and-investor-solutions'
   },
   {
      icon: StartedCreateIcon,
      iconBg: 'bg-getStarted-create-light',
      description: 'Buat akun gratis Anda dan mulai jelajahi ekosistem Tomazz.',
      label: 'Daftar Gratis',
      labelColor: 'text-getStarted-create',
      href: '/register'
   }
]

export default function GetStartedModal() {
   const [isOpen, setIsOpen] = useState(false)

   // Kunci scroll halaman di belakang modal (lihat hook untuk alasan tekniknya).
   useBodyScrollLock(isOpen)

   return (
      <>
         <button
            type="button"
            className="flex items-center gap-1.5 rounded-full border-0 bg-info px-2.5 py-2 hover:cursor-pointer sm:gap-2 sm:px-4"
            onClick={() => setIsOpen(true)}>
            {/* text-white: warna ikon kini mengikuti currentColor */}
            <GetStartedIcon className="h-6 shrink-0 text-white" />
            {/* Di mobile (<640px) hanya ikonnya yang tampil supaya grup tombol di header
                tidak memakan lebar. Label tetap ada di DOM & dibaca screen reader. */}
            <p className="hidden text-xs font-medium text-white sm:block">Mulai Sekarang</p>
         </button>

         {isOpen && (
            <>
               <div
                  className="fixed inset-0 z-[300] bg-black/50"
                  onClick={() => setIsOpen(false)}
               />
               <div
                  className="fixed inset-0 z-[301] flex items-center justify-center p-4"
                  onClick={() => setIsOpen(false)}>
                  <div
                     role="dialog"
                     aria-modal="true"
                     aria-labelledby="get-started-modal-title"
                     onClick={(e) => e.stopPropagation()}
                     /* max-h + flex-col: tinggi modal dibatasi terhadap layar (di mobile
                        lebih pendek), lalu daftar opsinya yang di-scroll — bukan seluruh
                        modal ikut memanjang melewati layar. `overflow-hidden` menjaga sudut
                        membulatnya tetap rapi saat isinya di-scroll. */
                     className="relative flex max-h-[80vh] w-full max-w-[600px] flex-col overflow-hidden rounded-2xl bg-white p-5 md:max-h-[85vh] md:p-8">
                     <button
                        type="button"
                        aria-label="Tutup"
                        onClick={() => setIsOpen(false)}
                        className="absolute right-4 top-4 border-0 bg-white p-0 text-secondary hover:cursor-pointer">
                        <IoClose size={24} />
                     </button>
                     <h2
                        id="get-started-modal-title"
                        className="shrink-0 pr-8 text-xl font-semibold text-primary md:text-2xl">
                        Apa yang ingin Anda lakukan?
                     </h2>
                     <p className="mt-1 shrink-0 text-sm text-secondary md:text-base">
                        Temukan alur perjalanan dan onboarding yang tepat sesuai tujuan investasi
                        atau transaksi bisnis Anda.
                     </p>
                     {/* min-h-0 wajib: tanpa itu, flex item tidak boleh menyusut di bawah
                         tinggi kontennya sehingga `overflow-y-auto` tidak pernah aktif dan
                         modal tetap memanjang. */}
                     <div className="mt-5 grid min-h-0 grid-cols-1 gap-4 overflow-y-auto sm:grid-cols-2">
                        {options.map((option, index) => {
                           const Icon = option.icon
                           return (
                              <div
                                 key={index}
                                 className="relative flex flex-col justify-between rounded-xl border border-solid border-lighter p-4">
                                 <div className="border-x-0 border-b border-t-0 border-solid border-b-lighter pb-4">
                                    <div
                                       className={`flex size-10 items-center justify-center rounded-lg ${option.iconBg}`}>
                                       <Icon className="size-6" />
                                    </div>
                                    <p className="mt-3 text-sm text-primary">
                                       {option.description}
                                    </p>
                                 </div>
                                 <SmartLink
                                    isNextUrl={option.href === '/register' ? false : true}
                                    href={option.href}
                                    onClick={() => setIsOpen(false)}
                                    className={`mt-4 flex items-center gap-1 pt-3 text-sm font-medium no-underline before:absolute before:inset-0 before:content-[''] ${option.labelColor}`}>
                                    {option.label}
                                    <HiChevronRight size={16} />
                                 </SmartLink>
                              </div>
                           )
                        })}
                     </div>
                  </div>
               </div>
            </>
         )}
      </>
   )
}